import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

import { AppHeader } from '../components/app-header';
import { ResourceDetailView } from '../components/resource-detail-view';

export default function ResourceDetailPage() {
  const { resourceType, resourceId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const organizationId = searchParams.get('organization_id') ?? undefined;

  // Logical "up": back to this type's list, not raw history — works on a
  // deep-linked detail (e.g. a migration committed_resource_id link).
  const backToList = () => {
    if (resourceType) {
      const q = organizationId ? `?organization_id=${organizationId}` : '';
      navigate(`/admin-v2/resources/${resourceType}${q}`);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Box sx={{ mb: 3 }}>
          <Button onClick={backToList} startIcon={<ArrowBack />}>
            Back to list
          </Button>
        </Box>
        <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
          Resource Explorer
        </Typography>
        {resourceType && resourceId ? (
          <ResourceDetailView
            resourceType={resourceType}
            resourceId={resourceId}
            organizationId={organizationId}
          />
        ) : (
          <Typography color="error">Missing resource type or id.</Typography>
        )}
      </main>
    </div>
  );
}
